'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatepickerSelect = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = require('react-moment-proptypes');

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _util = require('./util');

var _yearBar = require('./year-bar');

var _yearBar2 = _interopRequireDefault(_yearBar);

var _chevron = require('./chevron');

var _chevron2 = _interopRequireDefault(_chevron);

var _dayGrid = require('./day-grid');

var _dayGrid2 = _interopRequireDefault(_dayGrid);

var _monthGrid = require('./month-grid');

var _monthGrid2 = _interopRequireDefault(_monthGrid);

var _last30Days = require('./last-30-days');

var _last30Days2 = _interopRequireDefault(_last30Days);

var _calendarTypeToggle = require('./calendar-type-toggle');

var _calendarTypeToggle2 = _interopRequireDefault(_calendarTypeToggle);

var _datepickerButton = require('./datepicker-button');

var _datepickerButton2 = _interopRequireDefault(_datepickerButton);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Note that this Component's startDate and endDate props are used to help determine selectability
// for all child component elements (as call-throughs for util/date module methods).


var DatepickerSelect = exports.DatepickerSelect = function (_React$Component) {
  _inherits(DatepickerSelect, _React$Component);

  function DatepickerSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DatepickerSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatepickerSelect.__proto__ || Object.getPrototypeOf(DatepickerSelect)).call.apply(_ref, [this].concat(args))), _this), _this.setSelectedPickerType = function (pickerType) {
      var _this$props = _this.props,
          setSelectedPickerType = _this$props.setSelectedPickerType,
          id = _this$props.id;
      setSelectedPickerType(pickerType, id);
    }, _this.setPeriod = function (periodType, type, _ref2) {
      var quarter = _ref2.quarter,
          month = _ref2.month,
          _ref2$day = _ref2.day,
          day = _ref2$day === undefined ? 1 : _ref2$day,
          halfyear = _ref2.halfyear,
          year = _ref2.year,
          t30 = _ref2.t30,
          rollingQuarterMonth = _ref2.rollingQuarterMonth,
          week = _ref2.week;
      var _this$props2 = _this.props,
          setSelectedPeriod = _this$props2.setSelectedPeriod,
          setHoveringPeriod = _this$props2.setHoveringPeriod,
          id = _this$props2.id;
      var QUARTER_MONTHS = _constants2.default.QUARTER_MONTHS,
          HALFYEAR_MONTHS = _constants2.default.HALFYEAR_MONTHS;
      var date = '';

      if (month !== undefined) {
        date = (0, _momentTimezone2.default)({
          month: month,
          year: year,
          day: day
        }).format('YYYY-MM-DD');
      } else if (quarter) {
        date = (0, _momentTimezone2.default)({
          month: QUARTER_MONTHS[quarter],
          year: year,
          day: day
        }).format('YYYY-MM-DD');
      } else if (halfyear !== undefined) {
        date = (0, _momentTimezone2.default)({
          month: HALFYEAR_MONTHS[halfyear],
          year: year
        }).format('YYYY-MM-DD');
      } else if (t30) {
        date = (0, _momentTimezone2.default)().format('YYYY-MM-DD');
      } else if (rollingQuarterMonth) {
        date = (0, _momentTimezone2.default)({
          month: rollingQuarterMonth,
          year: year
        }).format('YYYY-MM-DD');
      } else if (week) {
        date = (0, _momentTimezone2.default)({
          year: year
        }).isoWeek(week).isoWeekday(1).format('YYYY-MM-DD');
      } else if (year) {
        date = (0, _momentTimezone2.default)(year, 'YYYY').format('YYYY-MM-DD');
      }

      var period = {
        date: date,
        type: type
      };

      if (periodType === 'selected') {
        // close out the date picker
        setSelectedPeriod(period, id);
      } else {
        setHoveringPeriod(period, id);
      }
    }, _this.enforceBackgroundSamplingStartDate = function (isBackgroundSamplingSelected, currentStartDate) {
      var backgroundSamplingEarliestDate = (0, _momentTimezone2.default)('2018-01-01');

      if (isBackgroundSamplingSelected) {
        return backgroundSamplingEarliestDate.isAfter(currentStartDate) ? backgroundSamplingEarliestDate : currentStartDate;
      }

      return currentStartDate;
    }, _this.hasPermissionForDay = function (month, year) {
      var endDate = _this.enforceAggregateScheduleRestrictions((0, _momentTimezone2.default)(_this.props.lastUpdated.lessThanQuarterly, 'YYYY-MM-DD'), _this.props.endDate);

      return (0, _util.hasDay)(_this.props.startDate, endDate, month, year);
    }, _this.hasPermissionForWeek = function (date) {
      var endDate = _this.enforceAggregateScheduleRestrictions((0, _momentTimezone2.default)(_this.props.lastUpdated.lessThanQuarterly, 'YYYY-MM-DD'), _this.props.endDate);

      return (0, _util.hasWeek)(_this.props.startDate, endDate, date);
    }, _this.hasPermissionForMonth = function (month, year) {
      var endDate = _this.enforceAggregateScheduleRestrictions((0, _momentTimezone2.default)(_this.props.lastUpdated.lessThanQuarterly, 'YYYY-MM-DD'), _this.props.endDate);

      var startDate = _this.enforceBackgroundSamplingStartDate(_this.props.isBackgroundSamplingSelected, _this.props.startDate);

      return (0, _util.hasMonth)(startDate, endDate, month, year);
    }, _this.hasPermissionForQuarter = function (quarter, year) {
      var endDate = _this.enforceAggregateScheduleRestrictions((0, _momentTimezone2.default)(_this.props.lastUpdated.quarterlyPlus, 'YYYY-MM-DD'), _this.props.endDate);

      var startDate = _this.enforceBackgroundSamplingStartDate(_this.props.isBackgroundSamplingSelected, _this.props.startDate);

      return (0, _util.hasQuarter)(startDate, endDate, quarter, year);
    }, _this.hasPermissionForRollingQuarter = function (month, year) {
      var endDate = _this.enforceAggregateScheduleRestrictions((0, _momentTimezone2.default)(_this.props.lastUpdated.quarterlyPlus, 'YYYY-MM-DD'), _this.props.endDate);

      var startDate = _this.enforceBackgroundSamplingStartDate(_this.props.isBackgroundSamplingSelected, _this.props.startDate);

      return (0, _util.hasRollingQuarter)(startDate, endDate, month, year);
    }, _this.hasPermissionForHalfYear = function (beginHalf, endHalf) {
      var endDate = _this.enforceAggregateScheduleRestrictions((0, _momentTimezone2.default)(_this.props.lastUpdated.quarterlyPlus, 'YYYY-MM-DD'), _this.props.endDate);

      var startDate = _this.enforceBackgroundSamplingStartDate(_this.props.isBackgroundSamplingSelected, _this.props.startDate);

      return (0, _util.hasHalfYear)(startDate, endDate, beginHalf, endHalf);
    }, _this.hasPermissionForYear = function (year) {
      var endDate = _this.enforceAggregateScheduleRestrictions((0, _momentTimezone2.default)(_this.props.lastUpdated.quarterlyPlus, 'YYYY-MM-DD'), _this.props.endDate);

      var startDate = _this.enforceBackgroundSamplingStartDate(_this.props.isBackgroundSamplingSelected, _this.props.startDate);

      return (0, _util.hasYear)(startDate, endDate, year);
    }, _this.enforceAggregateScheduleRestrictions = function (lastAggregateDate, currentEndDate) {
      if (!lastAggregateDate || !currentEndDate || !_momentTimezone2.default.isMoment(lastAggregateDate) || !_momentTimezone2.default.isMoment(currentEndDate)) {
        throw new Error('Requires lastAggregateDate and currentEndDate params to exist and be moment Objects!');
      }

      return lastAggregateDate.isBefore(currentEndDate) ? lastAggregateDate : currentEndDate;
    }, _this.rangeToStartAndEndMoments = function (start, end) {
      var dateRange = {};
      dateRange.startDate = (0, _momentTimezone2.default)(start, 'YYYY-MM-DD');

      if ((0, _momentTimezone2.default)(end).isAfter((0, _momentTimezone2.default)())) {
        dateRange.endDate = (0, _momentTimezone2.default)().startOf('day');
      } else {
        dateRange.endDate = (0, _momentTimezone2.default)(end, 'YYYY-MM-DD');
      }

      return dateRange;
    }, _this.handleClickOutside = function () {
      _this.props.close(_this.props.id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * @param  {Number} month
   * @param  {Number} year
   * @return {Boolean}
   */
  // checks if user has permission to view week
  // checks if user has permission to view month
  // checks if user has permission to view quarter
  // checks if user has permission to view quarter
  // checks if user has permission to view year

  /**
   * @param   {Object} lastAggregateDate - a moment Object representing the last aggregation date
   * @param   {Object} currentEndDate - the pre-aggregate restriction end date
   *
   * @returns {Object} a moment Object representing the new restricted end date
   */


  _createClass(DatepickerSelect, [{
    key: 'renderRollingQuarterButtons',
    value: function renderRollingQuarterButtons() {
      var _this2 = this;

      var _props = this.props,
          selectedPeriod = _props.selectedPeriod,
          enableRollingQuarters = _props.enableRollingQuarters;
      var previouslyCompletedQuarterMonth = (0, _momentTimezone2.default)().subtract(3, 'months').startOf('month');
      var currentRollingQuarterMonth = (0, _momentTimezone2.default)().subtract(2, 'months').startOf('month');
      var firstSundayOfMonth = (0, _momentTimezone2.default)().startOf('month').startOf('isoWeek').add(6, 'days'); // Check if we are past the first weekend of a new month to make sure we have an aggregate for a new current rolling quarter

      if ((0, _momentTimezone2.default)().isBefore(firstSundayOfMonth)) {
        previouslyCompletedQuarterMonth.subtract(1, 'month');
        currentRollingQuarterMonth.subtract(1, 'month');
      }

      if (!enableRollingQuarters) {
        return null;
      }

      return _react2.default.createElement('div', {
        className: _datepickerLocal2.default.rollingQuartersContainer
      }, _react2.default.createElement(_datepickerButton2.default, {
        'data-auto': 'lastCompletedRollingQuarter',
        disabled: !this.hasPermissionForRollingQuarter(previouslyCompletedQuarterMonth.month(), previouslyCompletedQuarterMonth.year()),
        active: selectedPeriod && selectedPeriod.type === 'rollingQuarter' && (0, _momentTimezone2.default)(selectedPeriod.date).month() === previouslyCompletedQuarterMonth.month(),
        onMouseEnter: function onMouseEnter() {
          return _this2.setPeriod('hovering', 'rollingQuarter', {
            rollingQuarterMonth: previouslyCompletedQuarterMonth.month(),
            year: previouslyCompletedQuarterMonth.year()
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setPeriod('hovering', '', {});
        },
        onClick: function onClick() {
          return _this2.setPeriod('selected', 'rollingQuarter', {
            rollingQuarterMonth: previouslyCompletedQuarterMonth.month(),
            year: previouslyCompletedQuarterMonth.year()
          });
        }
      }, 'Last Completed Rolling Quarter'), _react2.default.createElement(_datepickerButton2.default, {
        'data-auto': 'currentRollingQuarter',
        disabled: !this.hasPermissionForRollingQuarter(currentRollingQuarterMonth.month(), currentRollingQuarterMonth.year()),
        active: selectedPeriod && selectedPeriod.type === 'rollingQuarter' && (0, _momentTimezone2.default)(selectedPeriod.date).month() === currentRollingQuarterMonth.month(),
        onMouseEnter: function onMouseEnter() {
          return _this2.setPeriod('hovering', 'rollingQuarter', {
            rollingQuarterMonth: currentRollingQuarterMonth.month(),
            year: currentRollingQuarterMonth.year()
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setPeriod('hovering', '', {});
        },
        onClick: function onClick() {
          return _this2.setPeriod('selected', 'rollingQuarter', {
            rollingQuarterMonth: currentRollingQuarterMonth.month(),
            year: currentRollingQuarterMonth.year()
          });
        }
      }, 'Current Rolling Quarter'));
    }
  }, {
    key: 'renderMonthsCalendar',
    value: function renderMonthsCalendar() {
      var _this3 = this;

      var _props2 = this.props,
          currentYear = _props2.currentYear,
          setCurrentYear = _props2.setCurrentYear,
          selectedPeriod = _props2.selectedPeriod,
          hoveringPeriod = _props2.hoveringPeriod,
          id = _props2.id,
          halfyear = _props2.options.halfyear;
      return _react2.default.createElement('div', null, _react2.default.createElement(_yearBar2.default, {
        className: _datepickerLocal2.default.prevYearBar,
        quarter: 4,
        year: currentYear - 1,
        selectedPeriod: selectedPeriod,
        hoveringPeriod: hoveringPeriod,
        setPeriod: this.setPeriod,
        hasPermissionForQuarter: this.hasPermissionForQuarter,
        hasPermissionForMonth: this.hasPermissionForMonth
      }), _react2.default.createElement('div', {
        className: _datepickerLocal2.default.divider
      }), _react2.default.createElement(_chevron2.default, {
        direction: 'up',
        disabled: !this.hasPermissionForYear(currentYear - 1),
        handleClick: function handleClick() {
          return setCurrentYear(currentYear - 1, id);
        }
      }), _react2.default.createElement('div', {
        className: _datepickerLocal2.default.years
      }, _react2.default.createElement('button', {
        disabled: !this.props.enableYearSelection,
        onClick: function onClick() {
          _this3.setPeriod('selected', 'year', {
            year: currentYear
          });
        },
        onMouseEnter: function onMouseEnter() {
          if (_this3.props.enableYearSelection) {
            _this3.setPeriod('hovering', 'year', {
              year: currentYear
            });
          }
        },
        onMouseLeave: function onMouseLeave() {
          _this3.setPeriod('hovering', '', {});
        },
        className: (0, _classnames3.default)(_datepickerLocal2.default.button, _datepickerLocal2.default.year, _datepickerLocal2.default.yearHeading, _defineProperty({}, _datepickerLocal2.default.active, selectedPeriod.type === 'year' && currentYear === (0, _momentTimezone2.default)(selectedPeriod.date, 'YYYY-MM-DD').year()))
      }, currentYear)), _react2.default.createElement(_monthGrid2.default, {
        currentYear: currentYear,
        allowHalfYears: halfyear,
        id: id,
        selectedPeriod: selectedPeriod,
        hoveringPeriod: hoveringPeriod,
        setCurrentYear: setCurrentYear,
        setPeriod: this.setPeriod,
        hasPermissionForMonth: this.hasPermissionForMonth,
        hasPermissionForQuarter: this.hasPermissionForQuarter,
        hasPermissionForHalfYear: this.hasPermissionForHalfYear
      }), _react2.default.createElement(_chevron2.default, {
        direction: 'down',
        disabled: !this.hasPermissionForYear(currentYear + 1),
        handleClick: function handleClick() {
          return setCurrentYear(currentYear + 1, id);
        }
      }), _react2.default.createElement('div', {
        className: _datepickerLocal2.default.divider
      }), _react2.default.createElement(_yearBar2.default, {
        className: _datepickerLocal2.default.nextYearBar,
        quarter: 1,
        year: currentYear + 1,
        selectedPeriod: selectedPeriod,
        hoveringPeriod: hoveringPeriod,
        setPeriod: this.setPeriod,
        hasPermissionForQuarter: this.hasPermissionForQuarter,
        hasPermissionForMonth: this.hasPermissionForMonth
      }), this.renderRollingQuarterButtons());
    }
  }, {
    key: 'renderDaysCalendar',
    value: function renderDaysCalendar() {
      var _props3 = this.props,
          selectedPeriod = _props3.selectedPeriod,
          hoveringPeriod = _props3.hoveringPeriod,
          lastUpdated = _props3.lastUpdated,
          t30 = _props3.options.t30,
          enableLast30Days = _props3.enableLast30Days,
          setSelectedMonth = _props3.setSelectedMonth,
          selectedMonth = _props3.selectedMonth,
          id = _props3.id,
          setHoveringPeriod = _props3.setHoveringPeriod;
      return _react2.default.createElement('div', null, _react2.default.createElement(_dayGrid2.default, {
        aggregatesLastUpdated: lastUpdated.lessThanQuarterly,
        id: id,
        startDate: this.props.startDate.format('YYYY-MM-DD'),
        endDate: this.props.endDate.format('YYYY-MM-DD'),
        selectedMonth: selectedMonth,
        selectedPeriod: selectedPeriod,
        setPeriod: this.setPeriod,
        setSelectedMonth: setSelectedMonth,
        setHoveringPeriod: setHoveringPeriod,
        hoveringPeriod: hoveringPeriod,
        hasPermissionForDay: this.hasPermissionForDay,
        hasPermissionForMonth: this.hasPermissionForMonth,
        hasPermissionForWeek: this.hasPermissionForWeek
      }), _react2.default.createElement(_last30Days2.default, {
        display: t30 && enableLast30Days,
        setPeriod: this.setPeriod,
        active: selectedPeriod && selectedPeriod.type === 't30'
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          selectedPickerType = _props4.selectedPickerType,
          enableDayPicker = _props4.enableDayPicker,
          close = _props4.close;
      return _react2.default.createElement('div', {
        className: _datepickerLocal2.default.datePicker
      }, enableDayPicker && _react2.default.createElement(_calendarTypeToggle2.default, {
        currentCalendar: selectedPickerType,
        setSelectedPickerType: this.setSelectedPickerType,
        close: close
      }), selectedPickerType === 'day' && enableDayPicker ? this.renderDaysCalendar() : this.renderMonthsCalendar());
    }
  }]);

  return DatepickerSelect;
}(_react2.default.Component);

DatepickerSelect.propTypes = {
  lastUpdated: _propTypes2.default.shape({
    lessThanQuarterly: _propTypes2.default.string,
    quarterlyPlus: _propTypes2.default.string
  }).isRequired,
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,
  endDate: _reactMomentProptypes2.default.momentObj.isRequired,
  currentYear: _propTypes2.default.number,
  selectedMonth: _propTypes2.default.number,
  selectedPickerType: _propTypes2.default.oneOf(['month', 'day']).isRequired,
  id: _propTypes2.default.string.isRequired,
  selectedPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    date: _propTypes2.default.string
  }).isRequired,
  hoveringPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(_constants2.default.datePickerPeriods),
    date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
  }).isRequired,
  options: _propTypes2.default.shape({
    halfyear: _propTypes2.default.bool,
    t30: _propTypes2.default.bool
  }),
  close: _propTypes2.default.func.isRequired,
  setSelectedPickerType: _propTypes2.default.func.isRequired,
  setSelectedPeriod: _propTypes2.default.func.isRequired,
  setHoveringPeriod: _propTypes2.default.func.isRequired,
  setCurrentYear: _propTypes2.default.func.isRequired,
  setSelectedMonth: _propTypes2.default.func.isRequired,
  enableDayPicker: _propTypes2.default.bool.isRequired,
  enableRollingQuarters: _propTypes2.default.bool.isRequired,
  enableLast30Days: _propTypes2.default.bool.isRequired,
  isBackgroundSamplingSelected: _propTypes2.default.bool,
  enableYearSelection: _propTypes2.default.bool
};
DatepickerSelect.defaultProps = {
  enableYearSelection: true
};
exports.default = (0, _reactOnclickoutside2.default)(DatepickerSelect);